import { Pipe, PipeTransform, inject, ChangeDetectorRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslationService } from './translation.service';

/**
 * Pipe de traduccion: `{{ 'COMMON.ACTIVE' | translate }}`. Impuro y suscrito al cambio de idioma
 * para re-renderizar cuando el usuario cambia el idioma (mismo patron de Electo).
 */
@Pipe({
  name: 'translate',
  standalone: true,
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly translation = inject(TranslationService);
  private readonly cdr = inject(ChangeDetectorRef);

  constructor() {
    this.translation.currentLang$
      .pipe(takeUntilDestroyed())
      .subscribe(() => this.cdr.markForCheck());
  }

  transform(key: string, params?: Record<string, unknown>): string {
    return this.translation.translate(key, params);
  }
}
